import { ACCORDION_PARTS } from './accordionParts';
import type { AccordionStyleConfig } from './types';

const BASE_STYLE = {
  container: {
    bg: 'page.surface',
    w: '100%',
  },
  button: {
    align: 'center',
    display: 'flex',
    fontWeight: 'heavy',
    bg: 'page.surface',
    cursor: 'pointer',
    transitionProperty: 'common',
    transitionDuration: 'normal',
    _focusVisible: {
      boxShadow: 'focus',
      position: 'relative',
    },
    _hover: {
      bg: 'interaction.surfaceHover',
    },
    _active: {
      bg: 'interaction.surfaceActive',
    },
    _disabled: {
      bg: 'interaction.surfaceDisabled',
      cursor: 'not-allowed',
    },
  },
  panel: {
    borderTop: '1px solid',
    borderColor: 'separator.divider',
  },
  icon: {
    color: 'feature.secondary',
    transitionProperty: 'common',
    transitionDuration: 'normal',
  },
};

const VARIANTS = {
  separate: {
    container: {
      border: '1px solid',
      borderColor: 'separator.border',
      borderRadius: 'md',
    },
    button: {
      borderRadius: 'inherit',
      _expanded: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      },
      _focusVisible: {
        borderBottomLeftRadius: 'inherit',
        borderBottomRightRadius: 'inherit',
      },
    },
    panel: {
      borderRadius: 'inherit',
    },
    icon: {},
  },
  compact: {
    container: {
      borderTop: '1px solid',
      borderColor: 'separator.border',
    },
    button: {},
    panel: {},
    icon: {},
  },
};

const SIZES: AccordionStyleConfig['sizes'] = {
  md: ({ variant }) => ({
    container: {
      mb: variant === 'separate' ? 1 : 'unset',
    },
    button: {
      fontSize: 'md',
      lineHeight: 'md',
      h: 5,
      px: 1.5,
    },
    panel: { p: 1.5 },
    icon: { fontSize: '1.125rem', marginInlineEnd: 1 },
  }),
  lg: ({ variant }) => ({
    container: {
      mb: variant === 'separate' ? 1.5 : 'unset',
    },
    button: {
      fontSize: 'lg',
      lineHeight: 'lg',
      h: 6,
      px: 2,
    },
    panel: { p: 2 },
    icon: { fontSize: '1.375rem', marginInlineEnd: 1.5 },
  }),
};

const DEFAULT_PROPS = {
  size: 'md',
  variant: 'separate',
} as const;

export const ACCORDION_STYLE_CONFIG: AccordionStyleConfig = {
  parts: ACCORDION_PARTS,
  baseStyle: BASE_STYLE,
  variants: VARIANTS,
  sizes: SIZES,
  defaultProps: DEFAULT_PROPS,
};
